module.exports = __webpack_public_path__ + "static/media/Lock.11f1e541.png";